import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1),
      },
      pautaTitle: {
        fontFamily: '"Exo 2", snas-serif',
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '24px',
        marginBottom: theme.spacing(1),
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      presentResults: {
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
        textAlign: 'left',
        margin: theme.spacing(2, 0, 1),
      },
      radioGroup: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        marginBottom: theme.spacing(1),
        '& .MuiFormControlLabel-root': {
          marginLeft: 20,
          marginRight: 20,
          [theme.breakpoints.down('xs')]: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
          },
          '&:first-of-type': {
            marginLeft: 0,
          },
        },
      },
      itemContainer: {
        margin: theme.spacing(2, 0, 2.5),
      },
      labelData: {
        fontSize: 15,
        lineHeight: '24px',
        margin: theme.spacing(0.5, 0),
      },
      labelDataStrong: {
        fontWeight: 700,
      },
      percentItem: {
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
        margin: theme.spacing(0.5, 0),
        color: sicrediStyle.primarySicredi,
        textAlign: 'right',
      },
      loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& svg': {
          marginRight: theme.spacing(1),
        },
      },
    }),
  { name: 'RespostaPautaModal' }
);
